import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import store from '@/store/store';
import {
  ref, onBeforeUnmount, onMounted, computed, watch,
} from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PrivacyScreenView',
  props: {
  top: { type: String, required: false, default: '0px' },
  left: { type: String, required: false, default: '0px' },
  maxWidth: { type: String, required: false, default: '100%' },
},
  setup(__props) {

const props = __props;

_useCssVars((_vm, _setup) => ({
  "23b7c928": (_vm.top),
  "533d9294": (_vm.left),
  "2fe23acf": (_vm.maxWidth)
}))




const screenActive = ref(false);
const timeout = computed(() => (store.getters.activeUser?.privacyScreenTimeout || 0) * 1000);
let timer = undefined as number | undefined;

const activityHandler = () => {
  if (timeout.value === 0) { return; }

  screenActive.value = false;
  if (timer !== undefined) { window.clearTimeout(timer); }
  timer = window.setTimeout(() => {
    screenActive.value = true;
  }, timeout.value);
};

watch(timeout, () => {
  if (timeout.value === 0) {
    screenActive.value = false;
    if (timer !== undefined) { window.clearTimeout(timer); }
  } else {
    activityHandler();
  }
});

const events = ['mousemove', 'keydown', 'wheel', 'click'];
events.forEach((e) => window.addEventListener(e, activityHandler));

onMounted(() => activityHandler());
onBeforeUnmount(() => {
  events.forEach((e) => window.removeEventListener(e, activityHandler));
});


return { __sfc: true,props, screenActive, timeout, timer, activityHandler, events }
}

})